import { Trans } from "../utils/i18n";
import React from "react";
import {validateEmailRegEx, validatePhoneNumber, validateVinRegEx} from "../Shared/FormField";
import DeviceWidget from "../FormComponents/DeviceWidget/DeviceWidget";
import {isArray} from "lodash";
import {addressConfigWithInvoice} from "./components/address";

const validProblem = (values, orderEntryState) => {
    const selectedProduct = orderEntryState && orderEntryState.products && orderEntryState.products.find(item => String(item.id) === product)
        || orderEntryState?.serialNumber?.product;
    const currentProblem = selectedProduct && selectedProduct.problems && selectedProduct.problems.find(item => parseInt(values.problem_1) === item.id);
    const currentProblem2 = currentProblem && currentProblem.problems?.find(item => parseInt(values.problem_2) === item.id);

    return values.problem_1 && values.problem_2;
};

export const hasProducts = (products) => {
    // In the case of array fields (e. g. in SelfRepairProductSelect or SelfRepairCheckout)
    // products is not an object like ({ [id]: [amount] }) but an array of products like [{id, amount}, ...]
    if (isArray(products)) {
        return products.filter(item => item && Number(item.amount ?? 0) > 0).length > 0;
    }

    return products && Object.values(products).filter(item => item && item !== "0").length > 0;
}

export const orderEntryConfigDemo = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "enableStepper": true,
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "defaultValues": {
        "private_or_company": "private",
    },
    "groups": [
        {
            "description": <Trans i18nKey={"orderEntry.description"}>Your device is not behaving as you expect? <a href={"https://b2x.com/"} title={'B2X'} target={'_blank'}>B2X</a> support you from here to provide a solution quickly. Please complete the form below and we will get back to you to resolve the situation.</Trans>,
            "fields": [
                {
                    "size": "full",
                    "component": "requesttypeselect"
                },
            ],
        },
        {
            "heading": <Trans i18nKey="orderEntry.productSelection">Product selection</Trans>,
            "description": <Trans i18nKey="orderEntry.productSelection.description"></Trans>,
            "id": "product_selection",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3 className={'mt-9'} style={{ marginBottom: 0 }}><Trans i18nKey={'orderEntry.model.pleaseSelect'}>Please select your model</Trans></h3>
                    </>,
                },
                {
                    "size": "full",
                    "component": "productconfig",
                    "disableColorSelection": true,
                },
            ],
        },
        {
            "heading": <Trans i18nKey="orderEntry.warrantyCheck">Warranty Check</Trans>,
            "description": <Trans i18nKey="orderEntry.productSelection.description"></Trans>,
            "id": "warrantyCheck",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        return <><DeviceWidget hidePrice hideBadge values={values}  />
                    </>},
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3 className={'mt-6'}><Trans i18nKey={'orderEntry.enterSerialNumber'}>Enter the serial number of your product</Trans></h3>
                    </>,
                    "conditionFunction": (values, orderEntryState) => {
                        return orderEntryState?.selectedProduct;
                    },
                },
                {
                    "component": "serialnumber",
                    "size": "full",
                    "required": true,
                    "uppercase": true,
                    "doNotShowConfirmDevice": true,
                    "conditionFunction": (values, orderEntryState) => {
                        return orderEntryState?.selectedProduct;
                    },
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3><Trans i18nKey={'orderEntry.upload-receipt-only'}>Upload receipt</Trans></h3>
                        <p><Trans i18nKey={'orderEntry.upload-receipt-only.description'}>Please upload your invoice or receipt. You can upload JPG, PNG or PDF files up to 20 MB size.</Trans></p>
                    </>,
                    "conditionFunction": (values, orderEntryState) => {
                        return orderEntryState?.selectedProduct && orderEntryState?.serialNumber;
                    },
                },
                {
                    "size": "full",
                    "component": "dropzoneform",
                    "type": "receipt",
                    "conditionFunction": (values, orderEntryState) => {
                        return orderEntryState?.selectedProduct && orderEntryState?.serialNumber;
                    },
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                return values.requesttype && orderEntryState?.selectedProduct;
            },
        },
        {
            "heading": <Trans i18nKey="orderEntry.repairModality">Repair Modality</Trans>,
            "description": <Trans i18nKey="orderEntry.problemDescription.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "problem_description",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        return <><DeviceWidget hidePrice values={values}  />
                    </>},
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.problem.heading'}>What happend?</Trans></h2>
                        <p><Trans i18nKey="orderEntry.problemDescription.description">Tell us about the problem. Select a category to continue</Trans></p>
                    </>,
                },
                {
                    "size": "full",
                    "component": "problemselectbig",
                    "hideProblemInput": true,
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                return values.requesttype && orderEntryState?.selectedProduct && orderEntryState.serialNumber?.success;
            },
        },
        {
            "heading": <Trans i18nKey="orderEntry.problemDescription">Problem description</Trans>,
            "id": "repairModality",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        return <><DeviceWidget hidePrice values={values}  />
                    </>},
                },
                // {
                //     "size": "full",
                //     "name": "margin",
                //     "component": "callback",
                //     "callback": (values, orderEntryState) => {
                //         return <>
                //             <div className={'mt-8'}>
                //                 <h2 className={'mb-0'}><Trans i18nKey="orderEntry.repairModality">Repair Modality</Trans></h2>
                //             </div>
                //         </>},
                // },
                {
                    "size": "full",
                    "component": "requesttypeselect",
                    "doNotResetForm": true,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'rma' && validProblem(values, orderEntryState) && !orderEntryState?.serialNumber?.warranty,
                    "callback": (values, orderEntryState) => {
                        const product = orderEntryState.selectedProduct;
                        return <><DeviceWidget  values={values}  style="alternative"/>
                    </>},
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        return <>
                            <p className='bg-white gap-3 rounded-lg p-6 b2x-shadow-md border border-2 border-secondary-900'>
                                <Trans
                                i18nKey={'orderEntry.price.disclaimer'}
                            >
                                * Initial Repair Fee shown is for the diagnostics, carton box (if required) and transport services and includes shipping, tax, and handling. This amount may vary depending on the country where the repair service will be performed. Once we have received and confirmed the issue with your device we will confirm to your e-mail the additional Device Repair Fee to fix this issue.  You will be requested to approve and pay this cost before we proceed to repair your device.
                            </Trans>
                            </p>
                        </>;
                    },
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'rma' && validProblem(values, orderEntryState) && orderEntryState.serialNumber?.warranty === false,
                },
                {
                    "size": "full",
                    "component": "self_repair_instructions",
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'self_repair',
                },
                ({ pageProps }) => ({
                    "size": "full",
                    "component": "selfrepairproductselect",
                    "maxQuantity": pageProps?.maxQuantity ?? 10,
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'self_repair',
                }),
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 className={'mt-9'} style={{ marginBottom: 0 }}><Trans i18nKey="orderEntry.problemDescription">Problem description</Trans></h2>
                    </>,
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3><Trans i18nKey={'orderEntry.problemImage'}>Images of defects</Trans></h3>
                        <p><Trans i18nKey={'orderEntry.problemImage.description'}>Please upload pictures showing the defects where possible. You can upload JPG, PNG or PDF files up to 20 MB size.</Trans></p>
                    </>,
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'rma',
                },
                {
                    "size": "full",
                    "component": "dropzoneform",
                    "type": "problem",
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'rma',
                },
                {
                    "size": "full",
                    "name": "problem_description",
                    "label": <Trans i18nKey="serialNumber.problemDescription">Problem description</Trans>,
                    "multiline": true,
                    "conditionFunction": (values, orderEntryState) => values.requesttype === 'rma',
                }
            ],
            "conditionFunction": (values, orderEntryState) => {
                const product = orderEntryState.selectedProduct;
                const validProblem = values.problem_1 && values.problem_2;

                return ( values.requesttype && product && validProblem && orderEntryState.serialNumber?.success );
            }
        },


        {
            "heading": <Trans i18nKey="orderEntry.yourDetails">Your Details</Trans>,
            "description": <Trans i18nKey="orderEntry.addressContact.description">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.</Trans>,
            "id": "address",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        const product = orderEntryState.selectedProduct;
                        return <><DeviceWidget  values={values} hideBadge={values.requesttype === 'self_repair'} />
                    </>},
                },
                ({ values, form }) => ({
                    size: "full",
                    component: "shoppingcart",
                    products: values.products,
                    transportProductId: values.transport_product_id,
                    onChangeTransportProduct: (transportProduct) => form.change("transport_product_id", transportProduct.id),
                    onRemoveProduct: (product) => form.change("products", values.products?.filter(p => p?.id !== product.id) ?? []),
                    onUpdateProductQuantity: (productId, amount) => form.change("products", values.products?.map(p => p?.id === productId ? { ...p, amount } : p) ?? []),
                    className: "b2x-shadow-md bg-white p-8 mt-4",
                    conditionFunction: (values, orderEntryState) => values.requesttype === 'self_repair',
                }),
                // {
                //     "size": "full",
                //     "component": "shippingbox",
                //     "conditionFunction": (values, orderEntryState) => values.requesttype === 'rma',
                // },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2><Trans i18nKey={'orderEntry.contactInfo'}>Contact info</Trans></h2>
                    </>,
                },
                ...addressConfigWithInvoice,
            ],
            "conditionFunction": (values, orderEntryState) => {
                const product = orderEntryState.selectedProduct;
                const validProblem = values.problem_1 && values.problem_2;

                if(values.requesttype === 'rma') {
                    return ( values.requesttype && product && validProblem && orderEntryState.serialNumber?.success );
                }

                return values.requesttype && product && validProblem && orderEntryState.serialNumber?.success && hasProducts(values.products);
            },
        },
        {
            "heading": <Trans i18nKey="common.checkout">Confirmation / Summary</Trans>,
            "description": <Trans i18nKey="orderEntry.termsandconditions.description"></Trans>,
            "id": "terms",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values, orderEntryState) => {
                        const product = orderEntryState.selectedProduct;
                        return <><DeviceWidget  values={values} hideBadge={values.requesttype === 'self_repair'} />
                    </>},
                },
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h2 style={{ marginBottom: 0}}><Trans i18nKey={'orderEntry.verifyAccountToPay'}>Verify your information</Trans></h2>
                    </>,
                },
                {
                    "size": "full",
                    "component": "verify_phone_number"
                },
                {
                    "name": "terms_of_service",
                    "label": <Trans i18nKey="orderEntry.termsandconditions.label">I have read and accept the <a href={route('termsandconditions')} target={'_blank'}>Terms & Conditions</a> and the <a href={route('privacy')} target={'_blank'}>Privacy Statement</a></Trans>,
                    "size": "full",
                    "type": "checkbox",
                    "required": true
                },
            ],
            "conditionFunction": (values, orderEntryState) => {
                const validProblem = values.problem_1 && values.problem_2;
                const validName = values?.private_or_company === "private" ? (values?.first_name && values?.last_name) : values?.name;
                const validAddress = validName && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);

                const validInvoiceAddress = values.deviating_invoice_address == true ? (values?.invoice_private_or_company === "private" ? (values?.invoice_first_name && values?.invoice_last_name) : values?.invoice_name) && values.invoice_city && values.invoice_street && values.invoice_zip && values.invoice_country_id : true;
                const product = orderEntryState.selectedProduct;

                return validProblem && product && orderEntryState.serialNumber?.success && validAddress && validInvoiceAddress && (values.requesttype === 'self_repair' && hasProducts(values.products) || values.requesttype === 'rma');
            },
        }
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="orderEntry.send">Send</Trans>,
                    "id": "confirmsend",
                    "size": "half",
                    "component": "button",
                    "action": "next",
                    "color": "secondary",
                    "conditionFunction": (values, orderEntryState) => {
                        const validProblem = values.problem_1 && values.problem_2;
                        const validName = values?.private_or_company === "private" ? (values?.first_name && values?.last_name) : values?.name;
                        const validAddress = validName && values.city && values.street && values.zip && values.country_id && validatePhoneNumber.test(values.phone) && validateEmailRegEx.test(values.email);
                        const product = orderEntryState.selectedProduct;

                        return ( validProblem && product && orderEntryState.serialNumber?.success && values.terms_of_service && orderEntryState?.verificationCodeResponse )
                                && !!validAddress;
                    }
                }
            ]
        }
    ]
}
